import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Button } from '@guildeducationinc/recess';
import ActionCard from '@shared/ActionCard/ActionCard';
import ActionCardButtons from '@shared/ActionCard/ActionCardButtons';
import ActionCardContent from '@shared/ActionCard/ActionCardContent';
import { CAREER_ACCELERATOR_URL, MOBILE_QUERY } from '@src/constants';
import { clickable } from '@src/analytics';

const CareerAcceleratorActionCard: React.FC = () => {
  const isMobile = useMediaQuery(MOBILE_QUERY);

  const content = {
    title: 'Career Accelerator',
    body:
      "Dive into our collection of short lessons to learn how the job search is done. We'll show you the tips and tricks, from resume writing to job hunting to the first day in your new role.",
    icon: {
      src: 'https://guild.imgix.net/student-home/career-center/career-circle-pictogram.svg',
      alt: 'Career Accelerator',
    },
    link: {
      body: 'Go to Career Accelerator',
      testid: 'career_accelerator_accordion_link',
      href: CAREER_ACCELERATOR_URL,
    },
  };

  return (
    <ActionCard icon={content.icon}>
      <ActionCardContent title={content.title} body={content.body} />
      <ActionCardButtons>
        <Button
          appearance='primary'
          fullWidth={isMobile}
          href={content.link.href}
          testid={content.link.testid}
          onClick={() => {
            clickable({
              product: 'home',
              loggedIn: true,
              tag: 'career_accelerator_card',
              text: 'go_to_career_accelerator',
              type: 'button',
            });
          }}
        >
          {content.link.body}
        </Button>
      </ActionCardButtons>
    </ActionCard>
  );
};

export default CareerAcceleratorActionCard;
